<div class="form-modal">
    <div class="form-modal__body">
      <div class="img-wrapper">
        <div class="title-wrapper">
          <h1>{{ isEditing ? 'Edit' : isNew ? 'Create New' : 'View' }} Announcement</h1>
        </div>
        <div class="close-button" (click)="onClose()">
          <i class="fa fa-times"></i>
        </div>
      </div>

      <form [formGroup]="announcementForm" (ngSubmit)="onSubmit()" class="announcement-form">
        <div class="form-wrapper-80">
          <div class="app-c-form-group">
            <label class="app-c-form--label" for="TemplateID">Select Template:</label>
            <select
              class="app-c-form-control"
              id="TemplateID"
              [attr.disabled]="isViewMode() ? '' : null"
              formControlName="TemplateID"
              (change)="onTemplateSelect($any($event.target).value)">
              <option value="">-- Select --</option>
              <option *ngFor="let template of templates" [value]="template.ID">{{ template.Title }}</option>
            </select>
            <div *ngIf="announcementForm.get('TemplateID')?.invalid && (announcementForm.get('TemplateID')?.touched || submitButtonPressed)" class="error-message">
              Template is required.
            </div>
          </div>

          <div class="app-c-form-group title-row">
            <label class="app-c-form--label" for="Title"><span class="required">*</span>Title:</label>
            <input
              class="app-c-form-control"
              id="Title"
              [readonly]="isViewMode()"
              formControlName="Title"
              placeholder="Announcement Title"
              type="text"
              [ngClass]="{'invalid': announcementForm.get('Title')?.invalid && (announcementForm.get('Title')?.touched || submitButtonPressed)}" />
            <div *ngIf="announcementForm.get('Title')?.invalid && (announcementForm.get('Title')?.touched || submitButtonPressed)" class="error-message">
              Title is required.
            </div>
          </div>

          <div class="app-c-form-group">
            <label class="app-c-form--label" for="Content"><span class="required">*</span>Content:</label>
            <ckeditor id="Content" [readonly]="isViewMode()" [editor]="Editor" formControlName="Content" [config]="config"></ckeditor>
            <div *ngIf="announcementForm.get('Content')?.invalid && (announcementForm.get('Content')?.touched || submitButtonPressed)" class="error-message">
              Content is required.
            </div>
          </div>

          <div class="app-c-form-group">
            <label class="app-c-form--label" for="Link"><b>Optional:</b> Select the Content to Link in Message</label>
            <select
              class="app-c-form-control"
              id="Link"
              [attr.disabled]="isViewMode() ? '' : null"
              formControlName="Link"
              (change)="onLinkSelect($any($event.target).value)">
              <option value="">None</option>
              <option *ngFor="let link of linkOptions" [value]="link">{{ link }}</option>
            </select>
          </div>

          <div class="form-group">
            <div class="date-fields">
              <div class="date-field end-date">
                <span class="required">*</span><label>Start Date:</label>
                <mat-form-field appearance="outline" class="wt-mat-form-field">
                  <input matInput [disabled]="isViewMode() || isStartDatePast()" [readonly]="true" [matDatepicker]="startPicker" [min]="minStartDate()" formControlName="StartDate" placeholder="Start Date">
                  <mat-datepicker-toggle matSuffix [for]="startPicker" [disabled]="isViewMode() || isStartDatePast()"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="startDateInvalid()" class="error-message">
                  Start Date is required.
                </div>
              </div>

              <div class="date-field">
                <span class="required">*</span><label>End Date:</label>
                <mat-form-field appearance="outline" class="wt-mat-form-field">
                  <input matInput [disabled]="isViewMode()" [readonly]="true" [matDatepicker]="endPicker" [min]="minEndDate()" formControlName="EndDate" placeholder="End Date">
                  <mat-datepicker-toggle matSuffix [for]="endPicker" [disabled]="isViewMode()"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="announcementForm.get('EndDate')?.invalid && (announcementForm.get('EndDate')?.touched || submitButtonPressed)" class="error-message">
                  End Date is required and must be after Start Date.
                </div>
              </div>
            </div>
          </div>

          <div class="fixed-footer">
            <a tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="onSubmit()" (keypress)="onSubmit()">
              {{ isEditing ? 'Update Announcement' : isNew ? 'Add Announcement' : 'Close' }}
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
